export const state = {
  maintenance: {
    message: '',
    startDateTime: '',
    endDateTime: '',
    allFlag: false,
    companyIdList: [
      {
        corporationName: '',
        companyId: '',
        companyName: ''
      }
    ]
  },
  maintenanceList: [],
  status: '',
  addData: {},
  updateData: {},
  selectedTenantList: [],
  previousSelectedList: [],
  isCancel: false,
  selectAllFlag: false
}
export const mutations = {
  setMaintenance(state, response) {
    if (response.data['data'] == null) {
      response.data['data'] = [{}]
    }
    state.maintenanceList = response.data['data']['maintenanceList']
    state.status = response.data['data']['status']
  },
  setMaintenanceDetail(state, response) {
    if (response.data['data'] == null) {
      response.data['data'] = [{}]
    }
    state.maintenance = response.data['data']
    state.selectedTenantList = response.data['data']['companyList']
    state.previousSelectedList = JSON.parse(
      JSON.stringify(response.data['data']['companyList'])
    )
  },
  inputUpdate(state, payload) {
    state.updateData[payload.name] = payload.value
  },
  inputAddUpdate(state, payload) {
    state.addData[payload.name] = payload.value
  },
  updateSelectedTenantList(state, payload) {
    for (var i = 0; i < payload.length; i++) {
      if (
        payload[i].checked &&
        !state.selectedTenantList.some(
          tenant => tenant.companyId === payload[i].companyId
        )
      ) {
        state.selectedTenantList.push(payload[i])
      } else if (
        !payload[i].checked &&
        state.selectedTenantList.some(
          tenant => tenant.companyId === payload[i].companyId
        )
      ) {
        const deleteIndex = state.selectedTenantList.findIndex(
          tenant => tenant.companyId === payload[i].companyId
        )
        state.selectedTenantList = state.selectedTenantList.toSpliced(
          deleteIndex,
          1
        )
      }
    }
  },
  clearUpdateData(state) {
    state.updateData = {}
  },
  clearAddData(state) {
    state.addData = {}
  },
  clearSelectedTenantList(state) {
    state.selectedTenantList = []
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/maintenanceModules/maintenanceMutation.js